import React from 'react';
import toast, { Toast } from "react-hot-toast";

export function toastMessage(message:string){
  toast.dismiss();
  toast(message);
}

export function toastSuccess(message:string){
  toast.dismiss();
  toast.success(message);
}

export function toastError(message:string){
  toast.dismiss();
  toast.error(message);
}

export function toastCustomError(message:string){
  toast.dismiss();
  toast.error(message, {
    position: "bottom-center",
    style: {
      background: 'black',
      color: '#fff',
    }
  });
}